import React from "react";
import "./PositionFilter.css";

export default function PositionFilter(props) {
  return (
    <button
      className={
        "position-filter " + (props.selected ? "position-filter-selected" : "")
      }
      onClick={(e) => {
        e.preventDefault();
        props.updatePositionFilter(props.rosterSlot);
      }}
    >
      {props.rosterSlot}
    </button>
  );
}
